import { markdownAstFromString } from './markdownAstFromString';
import { markdownAstToDom } from './markdownAstToDom';

export function markdownToDom(document: Document, markdown: string) {
  const markdownAst = markdownAstFromString(markdown);
  return markdownAstToDom(document, markdownAst);
}
